<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { ref, defineEmits } from "vue";
import blogBg from "@/assets/blog_bg.webp";
import SearchIcon from "@/components/icons/SearchIcon.vue";

const { t } = useI18n();

const emit = defineEmits<{
  (e: "search", search: string): void;
}>();

const search = ref<string>("");
</script>

<template>
  <div
    class="overflow-hidden sticky xl:-top-[170px] xl:h-[342px] md:h-[259px] md:-top-[107px] h-[204px] -top-[68px] w-full z-40 bg-cover bg-center transition-all duration-500 ease"
    :style="{
      backgroundImage: `url(${blogBg})`,
    }"
  >
    <div
      class="absolute w-full inset-0 flex flex-col items-start justify-end px-4 md:px-6 xl:px-[71px]"
    >
      <div class="absolute inset-0 bg-mono-brown-gradient"></div>
      <p
        class="yeseva-one font-normal text-5xl md:text-[64px] xl:text-8xl text-white z-10 mb-[14px] md:mb-8 xl:mb-10"
      >
        {{ t("blog.search.title") }}
      </p>
      <div
        class="relative w-full h-12 xl:h-[60px] shrink-0 mx-auto bg-[#29160E33] rounded-[100px] overflow-hidden border border-[#FFFFFFBF] backdrop-blur-[30px] mb-4 md:mb-6 xl:mb-[26px] z-10"
      >
        <input
          name="blog-search"
          type="text"
          autocomplete="off"
          v-model="search"
          :placeholder="t('blog.search.search_placeholder')"
          class="flex-1 w-full h-full sf-pro font-normal text-sm leading-[21px] md:text-base md:leading-[24px] xl:text-xl xl:leading-[28px] bg-transparent pl-4 py-3 xl:pl-6 xl:py-4 placeholder:text-muted focus:outline-none text-white"
          @keyup.enter="emit('search', search)"
        />
        <span
          class="absolute right-[2px] top-[2px] size-[42px] xl:size-[54px] flex items-center justify-center rounded-full bg-orange-gradient transition-transform z-10 hover:cursor-pointer"
          @click="emit('search', search)"
        >
          <SearchIcon />
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.slide-up {
  transform: translateY(-170px);
}
</style>
